import { combineReducers } from 'redux';
import { appStateReducer } from './appStateReducer';

const allReducers = {
  appState: appStateReducer,
};

export const rootReducer = combineReducers(allReducers);
